// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Opakujte pokus s použitím data dokončení, jako je toto: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Skupina',
  chart_labelSeries: () => 'Série',
  chart_labelValue: () => 'Hodnota',
  checkboxSet_requiredMessageDetail: () => 'Požadováno',
  checkbox_requiredMessageDetail: () => 'Požadováno',
  close: () => 'Zavřít',
  collection_noData: () => 'Žádná data pro zobrazení.',
  collection_selectAllRows: () => 'Vybrat všechny řádky',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Vybrat řádku ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'Nelze řadit',
  collection_sortEnabled: () => 'Seřaditelné',
  confirmation: () => 'Potvrzení',
  dataVisualization_labelAndValue: (p: { LABEL: string; VALUE: string }) =>
    p['LABEL'] + ': ' + p['VALUE'],
  dataVisualization_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' z celkem ' + p['totalCount'],
  dataVisualization_noData: () => 'Žádná data pro zobrazení',
  dataVisualization_stateSelected: () => 'Vybráno',
  dataVisualization_stateUnselected: () => 'Výběr zrušen',
  error: () => 'Chyba',
  expandableList_expandCollapseInstructionText: () =>
    'Pomocí kláves se šipkami obsah rozbalíte a sbalíte',
  expandableList_groupCollapse: () => 'Sbaleno',
  expandableList_groupExpand: () => 'Rozbaleno',
  filePicker_addFiles: () => 'Přidat soubory',
  filePicker_dropzonePrimaryText: () => 'Přetáhnout',
  filePicker_dropzoneSecondaryText: () => 'Vyberte soubor, nebo jej přetáhněte sem',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Vyberte, nebo přetáhněte soubor sem',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Nelze odesílat soubory typu: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Odesílejte pouze po jednom souboru',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Nelze odesílat soubory typu ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'neznámý',
  formControl_clear: () => 'Vymazat',
  formControl_day: () => 'Den',
  formControl_helpAvailable: () => 'Je dostupná nápověda',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Dosáhli jste limitu ' +
    ((
      {
        one: new Intl.NumberFormat('cs').format(p['CHARACTER_LIMIT']) + ' znaku',
        few: new Intl.NumberFormat('cs').format(p['CHARACTER_LIMIT']) + ' znaků',
        many: new Intl.NumberFormat('cs').format(p['CHARACTER_LIMIT']) + ' znaku'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('cs').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('cs').format(p['CHARACTER_LIMIT']) + ' znaků') +
    '.',
  formControl_loading: () => 'Načítání',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maximální délka ' + p['MAX_LENGTH'] + ' překročena.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' zbývajících znaků.',
  formControl_month: () => 'Měsíc',
  formControl_readOnly: () => 'Pouze ke čtení',
  formControl_requiredMessageDetail: () => 'Zadejte hodnotu.',
  formControl_year: () => 'Rok',
  gantt_labelDate: () => 'Datum',
  gantt_labelEnd: () => 'Konec',
  gantt_labelLabel: () => 'Popisek',
  gantt_labelRow: () => 'Řádka',
  gantt_labelStart: () => 'Začátek',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nebyl nalezen žádný odpovídající oddíl.',
  indexer_keyboardInstructionText: () => 'Stisknutím klávesy Enter vyberte hodnotu.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Mezi ' + p['FROM_SECTION'] + ' a ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Dvojitým klepnutím a přidržením přejděte do režimu gest, poté tažením nahoru nebo dolů upravte hodnotu.',
  info: () => 'Informace',
  inputDateMask_date_cleared: () => 'Datum zúčtování',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Prázdné',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'rrrr',
  inputNumber_converterParseError: () => 'Zadejte číslo.',
  inputNumber_decrease: () => 'Snížení',
  inputNumber_increase: () => 'Zvýšení',
  inputPassword_hidden: () => 'Heslo skryté',
  inputPassword_hide: () => 'Skrýt heslo',
  inputPassword_show: () => 'Zobrazit heslo',
  list_suggestion: () => 'Doporučení',
  messageToast_allMessagesClosed: () => 'Všechny informační zprávy jsou zavřeny.',
  message_close: () => 'Zavřít',
  message_confirmation: () => 'Úspěch',
  message_error: () => 'Chyba',
  message_info: () => 'Informace',
  message_navigationFromMessagesRegion: () =>
    'Vstupujete do oblasti zpráv. Stisknutím klávesy F6 můžete přecházet zpět k dříve zaměřenému prvku.',
  message_navigationToMessagesRegion: () =>
    'V oblasti zpráv se nacházejí nové zprávy. Stisknutím klávesy F6 přejděte k naposledy otevřené oblasti zpráv.',
  message_warning: () => 'Varování',
  noData_message: () => 'Neexistují položky k zobrazení',
  overflowItemLabel: () => 'Další karty',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'Probíhá',
  radio_helpForRadio: () => 'Nápověda k přepínači',
  radio_requiredMessageDetail: () => 'Vyberte hodnotu.',
  selectMultiple_apply: () => 'Použít',
  selectMultiple_back: () => 'Zpět',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Vybranou hodnotu odstraníte stisknutím klávesy Baskspace nebo Delete.',
  selectMultiple_selectedValues: () => 'Vybrané hodnoty',
  selectMultiple_showSelectedValues: () => 'Zobrazit pouze vybrané hodnoty.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' -  vybrané hodnoty.',
  select_addToList: () => 'Přidat do seznamu',
  select_addToListAvailable: () => 'Je dostupné přidání do seznamu',
  select_moreSearchOptions: () => 'Další volby vyhledávání',
  select_moreSearchOptionsAvailable: () => 'Jsou dostupné další možnosti vyhledávání',
  select_noMatchesFound: () => 'Nebyly nalezeny žádné shody.',
  select_oneMatchFound: () => 'Nalezena jedna odpovídající položka',
  select_requiredMessageDetail: () => 'Vyberte hodnotu.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' - počet nalezených shod',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' nebo více shod nalezeno',
  selector_selected: () => 'Zaškrtávací políčko zaškrtnuto',
  selector_unselected: () => 'Zaškrtávací políčko nezaškrtnuto',
  tabBarNavigationList_removeCueText: () => 'Lze odebrat',
  timeComponent_tooltipZoomIn: () => 'Přiblížit',
  timeComponent_tooltipZoomOut: () => 'Oddálit',
  train_current: () => 'Aktuální',
  train_message_type: () => 'Typ zprávy',
  train_not_visited: () => 'Nenavštíveno',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Krok ' + p['currentStep'] + ' z ' + p['numberOfSteps'],
  train_visited: () => 'Navštíveno',
  userAssistance_learnMore: () => 'Další informace',
  userAssistance_required: () => 'Požadováno',
  viz_drillable: () => 'Lze procházet',
  warn: () => 'Varování'
};
export default bundle;
